export const getLabelFromCmsComponent = (component, key) => {
    if (component && component.Labels) {
        return component.Labels.find((el) => el.Key === key)?.Phrase || "";
    }
    return "";
};

export const getSystemMessageCmsFetchers = (candidateCMSData) => {
    const pageContent = candidateCMSData?.pageContent || {};

    return {
        fetchSystemMessageLabel: (key) =>
            getLabelFromCmsComponent(pageContent["Candidates.SystemMessage"], key),
        fetchCommonComponentLabel: (key) =>
            getLabelFromCmsComponent(pageContent["CommonComponent"], key),
        fetchSystemMessageValidationLabel: (key) =>
            getLabelFromCmsComponent(
                pageContent["Candidates.SystemMessageValidationText"],
                key
            ),
    };
};
